/**
 * v-debounce-click 指令
 * 指定时间内禁止重复点击，用于查询/搜索类按钮。
 * 使用 throttle-debounce 包（项目中已有此依赖）。
 *
 * 使用方式（替换 @click）：
 *   <button class="btn" v-debounce-click:500="handleSearch">搜索</button>
 *   <el-button v-debounce-click:500="handleQuery">查询</el-button>
 *
 * 参数说明：
 *   arg  = 防抖间隔（毫秒），默认 500
 *   value = 点击时调用的函数
 */
import { debounce } from "throttle-debounce";

export default {
  bind(el, binding) {
    const delay = parseInt(binding.arg, 10) || 500;
    const fn = binding.value;
    if (typeof fn !== "function") return;

    const debouncedHandler = debounce(delay, function (event) {
      fn(event);
    });

    el._debounceClickHandler = debouncedHandler;
    el.addEventListener("click", debouncedHandler);
  },
  unbind(el) {
    if (el._debounceClickHandler) {
      el.removeEventListener("click", el._debounceClickHandler);
      // throttle-debounce 的 cancel 方法
      if (typeof el._debounceClickHandler.cancel === "function") {
        el._debounceClickHandler.cancel();
      }
      delete el._debounceClickHandler;
    }
  },
};



// WEBPACK FOOTER //
// ./src/directives/debounceClick.js